<template>
	<sf-modal-layout :show="display" title="ERP出库成本导入" :closeModal="closeModal" size="l">
		<el-row :gutter="24">
			<el-col :span="12" style="height: 180px;width:50%">
				<el-upload
					action=""
					ref="upload"
					class="single-upload"
					:limit="1"
					:show-file-list="true"
					:file-list="fileList"
					:on-error="uploadError"
					:on-remove="fileOnRemove"
					:auto-upload="false"
					:http-request="fileUpload"
					:on-change="handleFileChange"
					:multiple="false"
				>  <!-- :on-exceed="uploadExceed" -->
					<!-- <el-button type="primary" size="small">上传</el-button> -->
					<sf-button type="primary" line icon="excel" >  {{ getMessage_('QWCC000927') }}</sf-button>
				</el-upload>
			</el-col>
		</el-row>
		<el-row :gutter="24"> 
		</el-row>
		<template v-slot:footer>
			<sf-button line :onClick="closeModal">
				{{ getMessage_('QWCC001971') }}
			</sf-button>
			<sf-button line :onClick="addAction" style="width: fit-content !important">
				{{ getMessage_('QWCC001488') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import * as yup from 'yup';

export default {
	props: {
		scrId: { type: String, default: '' } // 부모로부터 받는 데이터 정의
	},
	data() {
		//해당 컴포넌트안에서 사용하는 상태 정의(지역변수)
		return {
			display: false,
			fileList: []
		};
	},
	components: {},
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed,
		schema() {
			return yup.object().shape({
				//URL체크 ARRAY 형식이 아닌 단독으로 VALIDATION 체크
				apiGubun: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000737')])) //{0}은(는) 팔수 입력 값 입니다. , API URL
			});
		}
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		open() {
			//받아온 파라미터로 팝업오픈상태와 팝업창 타이틀명 BE통신시(구분값을 던진다 ),flag:I면등록,U면수정
			this.fileList = [];
			this.display = true;
		},
		closeModal() {
			//닫기 버튼을 누를시 등록일경우에는 FileUpload.vue 리스트를 초기화한다.
			this.display = false;
		},
		
		uploadError(error,column){
			this.$sf_toast({ type: 'error', message: error });
		},
		addAction() {
			try {
				
				if (this.fileList.length === 0) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC000928') }); //첨부파일을 등록해주세요.
					return false;
				}
				this.uploadFile(this.fileList[0].raw)	
				//this.$sf_showMessage({
				//	type: 'confirm',
				//	icon: 'confirm',
				//	message: this.getMessage_('MWCC000555'), //저장하시겠습니까?
				//	buttons: [{ title: this.getMessage_('MWCC000502'), clickFn: this.uploadFile() }] //추가
				//});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		beforeUpload(file) {
			this.fileList = [];
			return true; 
		},
		fileUpload(options){
			const file = options.file;
			this.fileList = [file];
		},
		fileOnRemove(file,fileList){
			this.fileIdList = [];
		},
		handleFileChange(file, fileList) {
			this.fileList = [file]; 
		},
		async uploadFile(file) {
			this.$sf_toggleLoading(true);
			this.errMsg = '';
			const formData = new FormData();
			formData.append('file', file);
			try {
				const { body, header } = await this.addCostUpload_({ formData });
				//console.log(header);
				if (header?.code === 0) {
					this.$sf_toast({ type: 'ok', message: header.message });
					//파일리스트 초기화 및 팝업 닫는다.
					this.closeModal();
					this.$emit('Refresh');
				} else {
					this.$sf_toast({ type: 'error', message: header.message });
				}
			} catch (error) {
				console.log("error: ", error)
				this.$sf_toast({ type: 'error', message: error }); //다국어 처리 필요
				this.errMsg = 'An Internal Server Error happend. Please Try Again.';
				return error;
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>
